import { getPrinterDataByLodop, checkPrinterList } from '@print/utils/printSetting';
import { getUUID, getMultiTemplateErrorTEMP, getMultiTemplateErrorTEMP2 } from '@print/utils/connectWidget/common';
import store from '@/store';
const { state, dispatch } = store;
const { print: printState } = state;
const { CN, PDD, FXG, JD, KS, VIPMP, KM, CLODOP } = printState.widget;

export function deepClone(obj) {
  if (!obj) return;
  let newObj = new obj.constructor();

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const typeOfObject = Object.prototype.toString.call(obj[key]);
      if (typeOfObject.slice(8, typeOfObject.length - 1) === 'Object') {
        newObj[key] = deepClone(obj[key]);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  return newObj;
}
/**
 * 多平台控件链接判断
 * @param {*} vm
 * @param {*} ctrls
 * @returns
 */
export function isConnectCtrolToMultiTemplate(vm, ctrls = []) {
  const { $alert } = window._globel_vm;
  const unLinkedContrls = [];
  const LODOP = window.CLODOP2015_7028 ? window.getLodop() : undefined;
  const isNeedCloud = ctrls.indexOf('CN') > -1;
  const isNeedJDCloud = ctrls.indexOf('JD') > -1;
  const isNeedFxgCloud = ctrls.indexOf('FXG') > -1;
  const isNeedPddCloud = ctrls.indexOf('PDD') > -1;
  const isNeedKsCloud = ctrls.indexOf('KS') > -1;
  const isNeedVipCloud = ctrls.indexOf('VIPMP') > -1;
  let errorHtml = '',
    title = '';
  if (!LODOP) {
    unLinkedContrls.push('CLODOP');
  }

  Object.values(printState.widget).map(item => {
    if (ctrls.indexOf(item.code) > -1 && !(item.socket?.readyState == 1)) {
      unLinkedContrls.push(item.title);
    }
  });

  console.log('util', KM.socket);
  if (KM.socket?.readyState == 1) {
    if (unLinkedContrls.length === 0) {
      return [];
    }
    errorHtml = getMultiTemplateErrorTEMP(unLinkedContrls);
  } else {
    errorHtml = getMultiTemplateErrorTEMP2();
  }

  $alert(errorHtml.content, errorHtml.title, {
    dangerouslyUseHTMLString: true,
    showConfirmButton: false,
    width: 600,
  });

  return unLinkedContrls;
}

export function getPrintersByLodopMixCloud() {
  return new Promise((resolve, reject) => {
    const lodopPrinterList = getPrinterDataByLodop();
    if (CN.socket?.readyState == 1) {
      const requestParams = { cmd: 'getPrinters', requestID: getUUID(8, 16), version: '1.0' };
      if (!CN.printerList) {
        CN.socket && CN.socket.send(JSON.stringify(requestParams));
      }
      checkPrinterList('CN', () => {
        let printers = [].concat(lodopPrinterList);
        CN.printerList.printers?.forEach(item => {
          if (!lodopPrinterList.find(tar => tar.name === item.name)) {
            printers.push({ name: item.name, label: item.name, value: printers.length });
          }
        });
        resolve(printers);
      });
    } else {
      resolve(lodopPrinterList);
    }
  });
}

export function validatePrinter(datas, isPrintTemplateIntegrate = false) {
  return new Promise((resolve, reject) => {
    let filterData = [];
    if(isPrintTemplateIntegrate) {
        filterData = datas.filter(item => item.logisticsCompanyId);
    } else {
        filterData = datas.filter(item => item.templateId);
    }
    getPrintersByLodopMixCloud().then(data => {
      let noPrinterTemplates = [];
      let isDefaultPrinterUnlink = '';
      datas.forEach(item => {
        if (!data.find(tar => tar.name === item.printerName) && item.printerName) {
          if (!item.isDefault) {
            noPrinterTemplates.push(`${item.logisticsCompanyName || item.templateName}(${item.printerName})`);
          } else {
            isDefaultPrinterUnlink = item.printerName;
          }
        }
      });
      resolve({ noPrinterTemplates, isDefaultPrinterUnlink });
    });
  });
}
